import type { ReservationEvent } from './types.js';

// O5 (DESK-OPERATOR-AND-MAIL-BRIEF §2.2, ADR-0026): a booking's history as the
// desk reads it — « 27/10 14:05 · Modification · par Marie D. ». Pure: the
// person's short name arrives on the row (`operator_label`), worked out by the
// database, which is the only reader of the register.

/** French staff-facing names of the events `pms_log_event` writes. Anything
 *  else shows its own name rather than nothing. */
const EVENT_FR: Record<string, string> = {
  created: 'Création',
  modified: 'Modification',
  cancel: 'Annulation',
  room_assigned: 'Chambre attribuée',
  room_unassigned: 'Chambre retirée',
  confirm: 'Confirmation',
  unconfirm: 'Confirmation retirée',
  checkin: 'Arrivée',
  undo_checkin: 'Arrivée annulée',
  checkout: 'Départ',
  no_show: 'Non présenté',
  guarantee: 'Garantie (VAD ou virement)',
  seeded_from_vega: 'Import Vega',
  seed_cancelled: 'Annulée dans Vega',
  seed_unassigned: 'Chambre retirée (Vega)',
  confirmation_sent: 'Confirmation envoyée',
  channex_linked: 'Rattachée à Channex (n° OTA)',
};

export interface JournalLine {
  id: number;
  at: string;
  what: string;
  /** « par Marie D. »; « automatique » for a server job; null for a person's
   *  write from before the stamp (O3), which named only the login. */
  who: string | null;
}

export function journalLines(events: readonly ReservationEvent[]): JournalLine[] {
  return [...events]
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt) || b.id - a.id)
    .map((e) => ({
      id: e.id,
      at: e.createdAt,
      what: EVENT_FR[e.event] ?? e.event,
      who: e.operatorLabel ? `par ${e.operatorLabel}` : e.actor === null ? 'automatique' : null,
    }));
}
